import { useTheme } from "styled-components";
import { openMessage } from "utils/misc";
import { PlusIcon } from "common/Icons/Icons";
import { AddOrderButtonProps } from "@shared/features/tradingTerminal/common/types";

const AddOrderButton = ({
  addOrder,
  disabledMessage,
  size,
}: AddOrderButtonProps) => {
  const appTheme = useTheme();

  const onClick = () => {
    if (disabledMessage) {
      openMessage(disabledMessage, "warning");
    } else {
      addOrder();
    }
  };

  return (
    <PlusIcon
      style={{
        fill: disabledMessage
          ? appTheme.colors.secondaryText
          : appTheme.colors.primaryBlue,
        opacity: disabledMessage ? 0.5 : 1,
        cursor: "pointer",
        fontSize: size || 18,
      }}
      onClick={onClick}
    />
  );
};

export default AddOrderButton;
